import { FC } from 'react'
import { AddressContainerProps } from './typing'
import { AddressText } from './subcomponents'

const AddressContainer: FC<AddressContainerProps> = ({
  address2 = '',
  city = '',
  state = '',
  postalCode = ''
}) => {
  return (
    <div>
      <AddressText data-test="address-line-2">{address2}</AddressText>
      <AddressText data-test="city-state-postal-code">
        {city ? `${city},` : ''} {`${state} ${postalCode}`}
      </AddressText>
    </div>
  )
}

export default AddressContainer
